import styled from 'styled-components';

const PaginaBaseStyled = {
    Container: styled.div``,
};

export default PaginaBaseStyled;
